import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAccordionData } from 'src/app/models/accordionModel.interface';

@Injectable({
  providedIn: 'root',
})
export class AccordionApiService {
  private apiUrl: string = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getData(tag: string): Observable<IAccordionData[]> {
    const url = `${this.apiUrl}/Accordion/listQandA?tag=${tag}`;
    return this.http.get<IAccordionData[]>(url);
  }
}
